import { useEffect, useState } from "react";
import "./ContractDetailSidebar.scss";
import { useParams, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import ContractDetails from "./ContractDetails";
import BackArrow from "../../../utils/Images/BackArrow";
import VendorsDetails from "./VendorsDetails";
import Footer from "../../../components/Footer/Footer";
import Header from "../../../components/Assessment/Header/Header";
import ResourcesList from "./ResourcesList";
import ContractTimeSheet from "./ContractTimeSheet";
import ResourceListIcon from "../../../utils/Images/ResourcesList";
import { getContractDetailsById } from "../../../service/StaffAugumentation/StaffAugumentationApis";
import ContractDetailIcon from "../../../utils/Images/ContractDetailIcon";
import VendorDetailIcon from "../../../utils/Images/VendorDetailIcon";
import TimeSheetIcon from "../../../utils/Images/TimeSheetIcon";
const ContractDetailSidebar = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    searchParams.get("at") || "contractDetails",
  );
  useEffect(() => {
    const params: Record<string, string> = { at: selectedTab };
    setSearchParams(params, { replace: true });
  }, [selectedTab]);
  const handleActiveTab = (tabName: any) => {
    setSelectedTab(tabName);
  };
  // Contract info Api
  const { contractId } = useParams();
  const [contractDetails, setContractDetails] = useState<any>({});
  useEffect(() => {
    getContractDetailsApi();
  }, []);
  const getContractDetailsApi = async () => {
    try {
      const response = await getContractDetailsById(contractId);
      setContractDetails(response?.data.data);
    } catch (error) {
      console.error(error);
    }
  };
  const renderContent = (activeTabs?: string) => {
    switch (activeTabs) {
      case "contractDetails":
        return <ContractDetails contractDetails={contractDetails} />;
      case "vendorDetails":
        return <VendorsDetails contractDetails={contractDetails} />;
      case "resources":
        return <ResourcesList contractDetails={contractDetails} />;
      case "timeSheet":
        return <ContractTimeSheet />;
      default:
        return null;
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <Header />
      <div className="container-fluid contractDetails jobModuleStyle">
        <div className="row">
          <div className="col-md-12">
            <div className="skillsNameSec">
              <div className="arrowTitle">
                <div className="profileHeader">
                  <div
                    className="backArrow"
                    onClick={() => {
                      window.history.back();
                    }}
                  >
                    <BackArrow />
                  </div>
                  <div className="profileInfo">
                    <div className="basicDetails">
                      <div className="nameTag">
                        <span className="name">{contractDetails?.title}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap mt-4">
          <div className="col-sm-12 col-md-3 col-lg-2 contractSideBar">
            {/* Sidebar */}
            <div className="sidebar">
              <div className="assessmentList">
                <div
                  className={`tab ${selectedTab === "contractDetails" ? "active" : ""}`}
                  onClick={() => {
                    handleActiveTab("contractDetails");
                  }}
                >
                  <div className="iconJobText">
                    <ContractDetailIcon />
                    <h6>{t("CONTRACT.CONTRACT_DETAILS")}</h6>
                  </div>
                </div>
              </div>

              <div className="assessmentList">
                <div
                  className={`tab ${selectedTab === "vendorDetails" ? "active" : ""}`}
                  onClick={() => {
                    handleActiveTab("vendorDetails");
                  }}
                >
                  <div className="iconText">
                    <VendorDetailIcon />
                    <h6>{t("CONTRACT.VENDOR_DETAILS")}</h6>
                  </div>
                </div>
              </div>

              <div className="assessmentList">
                <div
                  className={`tab ${selectedTab === "resources" ? "active" : ""}`}
                  onClick={() => {
                    handleActiveTab("resources");
                  }}
                >
                  <div className="iconText">
                    <ResourceListIcon />
                    <h6>{t("RESOURCE.RESOURCE")}</h6>
                  </div>
                </div>
              </div>

              <div className="assessmentList">
                <div
                  className={`tab ${selectedTab === "timeSheet" ? "active" : ""}`}
                  onClick={() => {
                    handleActiveTab("timeSheet");
                  }}
                >
                  <div className="iconText">
                    <TimeSheetIcon />
                    <h6>{t("CONTRACT.TIME_SHEETS")}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-9 col-lg-10">
            <div className="content-area">{renderContent(selectedTab)}</div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContractDetailSidebar;
